import * as React from 'react';
import { GraphqlQuery } from 'requestapijs';
import { match, RouteComponentProps } from 'react-router';
import { Loading, Card } from 'sha-el-design/lib';
import { nestedAccess } from 'sha-el-design/lib/helpers';
import { QuestionnaireNode, QuestionnaireNodeConnection } from '../../../../schema';
import { questionnaireDetailsQuery } from './constant';
import { AddQuestionnaire } from './AddQuestionnaire';
import { Link } from 'react-router-dom';
import { Button } from 'sha-el-design';
import { toGlobalId } from '../../../helpers';

export class EditQuestionnaire extends React.Component<Props, {}> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <GraphqlQuery
        variables={{ id: this.props.match.params.id }}
        queryString={questionnaireDetailsQuery}
        render={(response: { questionnaire: QuestionnaireNode }, error, loading) => {
          if (error) {
            return <div>Something went wrong</div>;
          }
          return (
            <Loading
              isLoading={loading}
              render={() => (
                <div>
                  <AddQuestionnaire
                    questionnaire={{
                      name: response.questionnaire.name,
                      // active is passed through so saving an edit PRESERVES
                      // the status instead of force-activating.
                      active: response.questionnaire.active,
                      openingStatement: response.questionnaire.openingStatement,
                      closingStatement: response.questionnaire.closingStatement,
                      state: nestedAccess(response.questionnaire.state, 'id'),
                      town: nestedAccess(response.questionnaire.town, 'id'),
                      questions: response.questionnaire.questions.map((v) => toGlobalId(`QuestionNode:${v}`)) as any[],
                      id: response.questionnaire.id,
                    }}
                    selectedTown={{
                      node: response.questionnaire.town,
                      cursor: '',
                    }}
                    selectedQuestionnaireState={{
                      node: response.questionnaire.state,
                      cursor: '',
                    }}
                    selectedQuestions={(response.questionnaire.allQuestions.map((question) => {
                      return {
                        node: question,
                      };
                    })) as any}
                    {...this.props}
                  />
                </div>
              )}
            />
          );
        }}
      />
    );
  }
}

interface Props extends RouteComponentProps {
  match: match<{ id: string }>;
}
